
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { get } from 'jquery';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class HrserviceService {
  // Generic GET with auth headers for custom endpoints
  public getWithAuth(url: string, params: any = {}, responseType: any = 'json') {
    return this.http.get(url, { params, headers: this.headers, responseType });
  }

  // Get company list with filters and pagination
  getCompanyList(params: any): Observable<any> {
    const httpOptions = {
      headers: this.headers,
      params: params
    };
    return this.http.get(this.baseUrl + 'company_list/', httpOptions);
  }

  // Export company list with filters
  exportCompanyList(params: any): Observable<any> {
    const httpOptions = {
      headers: this.headers,
      params: params,
      responseType: 'arraybuffer' as 'json'
    };
    return this.http.get(this.baseUrl + 'company_list_export/', httpOptions);
  }

  // Get business list with filters and pagination
  getBusinessList(params: any): Observable<any> {
    const httpOptions = {
      headers: this.headers,
      params: params
    };
    return this.http.get(this.baseUrl + 'business_list/', httpOptions);
  }

  // Get business heads for dropdown
  getBusinessHeads(): Observable<any> {
    const httpOptions = {
      headers: this.headers
    };
    return this.http.get(this.baseUrl + 'business/heads/', httpOptions);
  }

  // Export business list with filters
  exportBusinessList(params: any): Observable<any> {
    const httpOptions = {
      headers: this.headers,
      params: params,
      responseType: 'arraybuffer' as 'json'
    };
    return this.http.get(this.baseUrl + 'business_list_export/', httpOptions);
  }

  baseUrl = environment.url + "travelex_app/api/v2/";
  access_key: string = localStorage.getItem("accessToken");
  headers: any = new HttpHeaders()
    .set("Authorization", `${this.access_key}`)
    .set("Content-Type", "application/json");
  requestOptions: any = { headers: this.headers };
  apiUrl: any;
  employeeInfoUrl = 'employee/';
  companiesUrl = 'company_list/';
  businessUrl = 'business_list/';
  deptUrl = 'department_list/';
  departmentUrl = 'business_dep_list/';
  empUrl= 'employee_list/';
  constructor(private http: HttpClient) { }


  EmployeeList(page: number, email: any) {
    this.apiUrl = `${this.baseUrl}admin/employees?page=${page}&email=${email}`;
    const url = this.apiUrl;
    return this.http.get(url, this.requestOptions);
  }

  holidayList() {
    this.apiUrl = `${this.baseUrl}admin/holidays`;
    const url = this.apiUrl;
    return this.http.get(url, this.requestOptions);
  }

  addHolidayList(data: any) {
    this.apiUrl = `${this.baseUrl}admin/addHoliday`;
    const url = this.apiUrl;
    console.log(data);
    return this.http.post(url, data, this.requestOptions);
  }

  deleteHolidayList(id: number): Observable<any> {

    this.apiUrl = `${this.baseUrl}admin/delete_holiday/${id}`;
    const url = this.apiUrl;

    return this.http.delete(
      url, this.requestOptions

    );
  }

  addPatrnity(userId: number, leave_count: number) {
    this.apiUrl = `${this.baseUrl}admin/add_paternity`;
    const url = this.apiUrl;
    const body = {
      user_id: userId,
      leave_count: leave_count,
    }

    return this.http.post(url, body, this.requestOptions);
  }

  employeeInfo(params) {
    const httpOptions = {
      headers: this.headers,
      params: params
    };
    return this.http.get(this.baseUrl + this.employeeInfoUrl, httpOptions);
  }

  addEmployeeInfo(params, data) {
    const httpOptions = {
      headers: this.headers,
      params: params
    };
    return this.http.put(this.baseUrl + this.employeeInfoUrl, data, httpOptions);
  }

  getEmployees() {
    return this.http.get(this.baseUrl + this.empUrl, this.requestOptions);
  }

  getCompanies() {
    return this.http.get(this.baseUrl + this.companiesUrl, this.requestOptions);
  }

  getDepartments() {
    return this.http.get(this.baseUrl + this.departmentUrl, this.requestOptions);
  }

  getBusiness() {
    return this.http.get(this.baseUrl + this.businessUrl, this.requestOptions);
  }

  getDept() {
    return this.http.get(this.baseUrl + this.deptUrl, this.requestOptions);
  }

  // New department list API with search, filter, and pagination
  getDepartmentList(params: any) {
    let queryParams = new HttpParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        queryParams = queryParams.append(key, params[key]);
      }
    });
    return this.http.get(this.baseUrl + 'department_list/', { params: queryParams, ...this.requestOptions });
  }

  // Department export API
  getDepartmentListExport(params: any) {
    let queryParams = new HttpParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        queryParams = queryParams.append(key, params[key]);
      }
    });
    return this.http.get(this.baseUrl + 'department_list_export/', { 
      params: queryParams, 
      ...this.requestOptions,
      responseType: 'blob' as 'json'
    });
  }

  // Employees export API with proper HttpParams and blob response
  getEmployeesExport(params: any) {
    let queryParams = new HttpParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        queryParams = queryParams.append(key, params[key]);
      }
    });
    return this.http.get(this.baseUrl + 'admin/employees_export', {
      params: queryParams,
      ...this.requestOptions,
      responseType: 'blob' as 'json'
    });
  }

  updateCompany(data){
    return this.http.put(this.baseUrl + this.companiesUrl, data, this.requestOptions);
  }

  createCompany(data){
    return this.http.post(this.baseUrl + this.companiesUrl, data, this.requestOptions);
  }

  updateBusiness(data){
    return this.http.put(this.baseUrl + this.businessUrl, data, this.requestOptions);
  }

  createBusiness(data){
    return this.http.post(this.baseUrl + this.businessUrl, data, this.requestOptions);
  }

  updateDept(data){
    return this.http.put(this.baseUrl + this.deptUrl, data, this.requestOptions);
  }

  createDept(data){
    return this.http.post(this.baseUrl + this.deptUrl, data, this.requestOptions);
  }
}
